import { useAppDispatch, useAppSelector } from "@/shared/lib/redux"
import { Modal } from "@/shared/ui/modal"
import notify from "@/shared/lib/notify"
import { getErrorMessage } from "@/shared/consts/error-codes"
import { useForm } from "react-hook-form"
import {
    closeUserDeleteRestoreModal,
    fetchUserDeleteOrRecover,
    selectIsUserDeleteRestoreModalOpen,
    selectUserDeleteRestoreMode,
    selectUserDeleteRestoreOnSuccess
} from "../../model"

export const ConfirmUserDeleteRestoreModal = () => {
    const dispatch = useAppDispatch()
    const isOpen = useAppSelector(selectIsUserDeleteRestoreModalOpen)
    const mode = useAppSelector(selectUserDeleteRestoreMode)
    const onSuccess = useAppSelector(selectUserDeleteRestoreOnSuccess)

    const handleClose = () => {
        dispatch(closeUserDeleteRestoreModal())
    }

    const onSubmit = async () => {
        await new Promise<void>((res, rej) => {
            dispatch(fetchUserDeleteOrRecover())
                .unwrap()
                .then(() => {
                    notify.success(mode === 'delete' ? 'Пользователь удалён' : 'Пользователь восстановлен')
                    onSuccess?.()
                    handleClose()
                    res()
                })
                .catch((e) => {
                    notify.error(getErrorMessage(e))
                    rej()
                })
        })
    }

    const { handleSubmit, formState: { isSubmitting } } = useForm()

    const title = mode === 'delete' ? 'Удаление пользователя' : 'Восстановление пользователя'
    const confirmText = mode === 'delete' ? 'Удалить' : 'Восстановить'
    const message =
        mode === 'delete'
            ? 'Пользователь будет помечен как удалённый, привязки к группам будут сняты. Продолжить?'
            : 'После восстановления пользователь будет в статусе «заблокирован», группы нужно назначить заново при необходимости. Продолжить?'

    return (
        <Modal isOpen={isOpen} title={title} onRequestClose={handleClose}>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-3">
                <div>{message}</div>
                <div className="w-full flex gap-3">
                    <button type="button" onClick={handleClose} className="form_cancel_button">
                        Отменить
                    </button>
                    <button disabled={isSubmitting} className="form_handle_button" type="submit">
                        {confirmText}
                    </button>
                </div>
            </form>
        </Modal>
    )
}
